var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgCommentsBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03201 21.996C0.846687 22.8267 1.50052 23.1783 2.1072 22.913L22.6114 12.657H22.6134C22.858 12.5224 23 12.28 23 12.0002C23 11.7203 22.858 11.4777 22.6134 11.3432H22.6114L2.1072 1.08701C1.50052 0.821636 0.846687 1.1734 1.03201 2.00416C1.04455 2.06043 2.25673 7.32761 2.9158 10.1922L13.6193 12.0002L2.9158 13.8079C2.25673 16.6723 1.04449 21.9396 1.03201 21.996Z",
    fill: "#096AD9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCommentsBtn);
export default __webpack_public_path__ + "static/media/img_comments_btn.663399e806510e84838e3da608c3ea25.svg";
export { ForwardRef as ReactComponent };